<template>
  <div>
    <div class="d-flex py-4">
      <div class="img_title_header ma-2 mr-4">
        <img src="@/assets/settings.png" height="" width="">
      </div>
      <div class="title_menu pl-2">
        <h2>เมนูจัดการเว็บไซต์</h2>
      </div>
    </div>
    <div class="grid_custom mt-3 pl-4">
      <v-card class="list_menu_content" elevation="4">
        <router-link to="/coversetting" class="menu_card_content d-flex flex-column justify-center align-center">
          <div class="img_menu_content">
            <img src="@/assets/picture_1.png">
          </div>
          <div class="title_menu_content">
            ตั้งค่ารูปภาพเว็บไซต์
          </div>
        </router-link>
      </v-card>
      <v-card class="list_menu_content" elevation="4">
        <router-link to="/companyinformation" class="menu_card_content d-flex flex-column justify-center align-center">
          <div class="img_menu_content">
            <img src="@/assets/process.png">
          </div>
          <div class="title_menu_content">
            ตั้งค่าข้อมูลบริษัท
          </div>
        </router-link>
      </v-card>
      <v-card class="list_menu_content" elevation="4">
        <router-link to="/ratesetting" class="menu_card_content d-flex flex-column justify-center align-center">
          <div class="img_menu_content">
            <img src="@/assets/motivation.png">
          </div>
          <div class="title_menu_content">
            ตั้งค่าข้อมูลการขาย
          </div>
        </router-link>
      </v-card>
      <v-card class="list_menu_content" elevation="4">
        <router-link to="/articlemanage" class="menu_card_content d-flex flex-column justify-center align-center">
          <div class="img_menu_content">
            <img src="@/assets/copywriting.png">
          </div>
          <div class="title_menu_content">
            บทความ
          </div>
        </router-link>
      </v-card>
      <v-card class="list_menu_content" elevation="4">
        <router-link to="/faqspage" class="menu_card_content d-flex flex-column justify-center align-center">
          <div class="img_menu_content">
            <img src="@/assets/settings_other.png">
          </div>
          <div class="title_menu_content">
            การตั้งค่าอื่นๆ
          </div>
        </router-link>
      </v-card>
      <div></div>
    </div>
  </div>

</template>

<script>
export default {
  name: "MenuWebsite"
}
</script>

<style scoped>
.grid_custom {
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-gap: 15px 0;
}
@media only screen and (max-width: 1000px) {
  .grid_custom {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
@media only screen and (max-width: 500px) {
  .grid_custom {
    display: grid;
    grid-template-columns: 100%;
  }
}
.list_menu_content {
  width: 95%;
}

.list_menu_content:first-child {
  margin-right: 5px;
}

.list_menu_content:last-child {
  margin-left: 5px;
}
.router-link-active,
.list_menu_content:hover {
  background-image: linear-gradient(to right, #8cc63e, #91c657, #9cc66d) !important;
  transition: 0.1s !important;
}

.list_menu_content:hover>.menu_card_content {
  color: #fff !important;
}

.menu_card_content {
  padding: 15px;
  text-decoration: none;
  color: rgba(0, 0, 0, 0.87) !important;
}

.img_menu_content {
  width: 100px;
}

.img_menu_content>img {
  max-width: 100%;
}

.title_menu_content {
  font-size: 20px;
}

.img_title_header{
  width: 50px;
}

.img_title_header > img{
  max-width: 100%;
}
</style>
